import $ from 'jquery';

const jsTooltips = () => {
    const tooltipBubbleClass = 'tooltip-info-bubble';
    const tooltipClass = 'js-tooltip';
    const tooltipSelector = `.${tooltipClass}`;
    const bodyGutter = 25;
    const arrowGutter = 0;
    const arrowSize = 16;

    if (!$(tooltipSelector).length) {
        return;
    }

    let triggers = false;
    let triggersTop = 0;
    let triggersLeft = 0;
    let triggersWidth = 0;
    let triggersHeight = 0;
    let tooltip = false;
    let title = false;
    let verticalPosition = 'top';
    let horizontalPosition = 'center';
    let posTop = 0;
    let posLeft = 0;

    function calculateTop() {
        if (triggersTop < (tooltip.outerHeight() + arrowGutter + arrowSize)) {
            verticalPosition = 'bottom';
        } else {
            verticalPosition = 'top';
        }
    }

    function calculateLeft() {
        if (triggersLeft - (tooltip.outerWidth() / 2) < bodyGutter * 2) {
            // if triggers too left, put tooltip on right
            horizontalPosition = 'right';
        } else if ($(window).width() - (triggersLeft + (tooltip.outerWidth() / 2) < (bodyGutter * 2))) {
            // if triggers too right, put tooltip on left
            horizontalPosition = 'left';
        } else {
            // if fit on center
            horizontalPosition = 'center';
        }
    }

    function placeTooltip() {
        const totalWidth = tooltip.outerWidth() + arrowSize + arrowGutter;
        const totalWidthWithGutter = tooltip.outerWidth() + arrowSize + arrowGutter + (bodyGutter * 2);
        const windowWidth = $(window).width();

        // get horizontal correction
        if (horizontalPosition === 'left') {
            if (triggers.offset().left - totalWidthWithGutter < 0) {
                horizontalPosition = 'full-right';
            }
        }

        if (horizontalPosition === 'right') {
            if (triggers.offset().left + triggersWidth + totalWidthWithGutter > windowWidth) {
                horizontalPosition = 'full-left';
            }
        }

        // get vertical correction
        if (horizontalPosition === 'left' || horizontalPosition === 'right') {
            verticalPosition = 'center';
        }

        // put bubble base on horizontalPosition
        switch (horizontalPosition) {
            case 'left':
                posLeft = triggers.offset().left - totalWidth;
                break;

            case 'right':
                posLeft = triggers.offset().left + triggersWidth + arrowGutter + arrowSize;
                break;

            case 'full-left':
                posLeft = bodyGutter;
                $(`.${tooltipBubbleClass}.arrow`).css('left', `${triggersLeft - posLeft}px`);
                break;

            case 'full-right':
                posLeft = windowWidth - (bodyGutter + tooltip.outerWidth());
                $(`.${tooltipBubbleClass}.arrow`).css('left', `${triggersLeft - posLeft}px`);
                break;

            case 'center':
                posLeft = triggersLeft - (tooltip.outerWidth() / 2);
                break;

            default:
        }

        // put bubble base on vertical
        switch (verticalPosition) {
            case 'center':
                posTop = triggers.offset().top - ((tooltip.outerHeight() / 2) - (triggersHeight / 2));
                break;

            case 'top':
                posTop = triggers.offset().top - (tooltip.outerHeight() + arrowGutter + arrowSize);
                break;

            case 'bottom':
                posTop = triggers.offset().top + (triggersHeight + arrowGutter + arrowSize);
                break;

            default:
        }
    }

    function infoTooltip() {
        if (triggers === false) {
            return;
        }

        // set max width
        if ($(window).width() < tooltip.outerWidth() * 1.5) {
            tooltip.css('max-width', ($(window).width() / 4) * 3);
        }

        // defines triggers
        triggersWidth = triggers.outerWidth();
        triggersHeight = triggers.outerHeight();
        triggersTop = triggers.offset().top - $(window).scrollTop();
        triggersLeft = triggers.offset().left + (triggersWidth / 2);

        calculateTop();
        calculateLeft();
        placeTooltip();

        tooltip.removeClass('top bottom left right center')
            .addClass(`${horizontalPosition} ${verticalPosition}`)
            .css({ left: posLeft, top: posTop })
            .animate({ opacity: 1 }, 50);
    }

    function removeTooltip() {
        if (tooltip === false) {
            return;
        }

        tooltip.animate({ opacity: 0 }, 50, function () {
            $(this).remove();
        });

        triggers.attr('title', title);

        triggers = false;
        title = false;
        tooltip = false;
    }

    // show tooltip on hover or touch
    $('body').on('mouseenter touchend focus', tooltipSelector, function (e) {
        e.preventDefault();
        e.stopPropagation();
        const checkTitle = $(this).attr('title');

        if (!checkTitle || checkTitle === '') {
            return;
        }

        removeTooltip();

        triggers = $(this);
        title = triggers.attr('title');
        tooltip = $(`<div class=${tooltipBubbleClass}></div>`);

        triggers.removeAttr('title');
        tooltip.css('opacity', 0)
            .html(`<div><p class="p-small">${title}</p></div><span class="arrow"></span>`)
            .appendTo('body');

        infoTooltip();
    });

    // hide tooltip on mouse leave
    // $('body').on('mouseleave blur', tooltipSelector, removeTooltip);

    // hide tooltip on touch other
    $('body').on('touchend click', e => {
        if ($(e.target).hasClass(tooltipClass) ||
        $(e.target).parents().hasClass(tooltipBubbleClass) ||
        $(e.target).closest(tooltipSelector).length > 0) {
            return;
        }

        removeTooltip();
    });

    // update tooltips position on resize/rotate
    $(window).resize(infoTooltip);
};

// Run the functions on document ready
$(() => {
    jsTooltips();
});
